import { QuickLinksType, TeaserType, TopResultsType } from '@react/SearchResults/SearchTypes'
import { SearchTopResultsCard } from '@react/SearchResults/subcomponents'

type SearchTopResultsProps = { teasers: TeaserType[]; topResults: TopResultsType; quickLinks: QuickLinksType }

export function SearchTopResults({ teasers, topResults, quickLinks }: SearchTopResultsProps) {
  if (!topResults?.items?.length && !quickLinks?.items?.length && !teasers) {
    return null
  }
  return (
    <div className="saas-search-result-tab__search-top-results" data-testid="saas-search-result-tab__search-top-results">
      {teasers?.map((teaser, index) => <SearchTopResultsCard key={index} searchObject={teaser} />)}
      {topResults?.items?.length > 0 && <SearchTopResultsCard searchObject={topResults} />}
      {quickLinks?.items?.length > 0 && <SearchTopResultsCard searchObject={quickLinks} />}
    </div>
  )
}
